module.exports = __webpack_public_path__ + "static/img/gongan.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FFP/images/gongan.png
// module id = F8Fa
// module chunks = 0